import { types, getParent } from 'mobx-state-tree';

import { Contact as BaseContact, removeEmptyProperties } from '../definitions/Common';
import { MaritalStatusEnum } from '../definitions/MaritalStatus';
import OptionalIdentifier from '../types/OptionalIdentifier';

import Asset from './Asset';
import Employment from './Employment';
import Expense from './Expense';


const MortgageContact = types
    .model({
        id: OptionalIdentifier,
        assets: types.array(Asset),
        employment: types.array(Employment),
        applicationRank: types.number, // used to specify order of clients
        maritalStatus: types.maybe(MaritalStatusEnum),
        expenses: types.array(Expense),
    })
    .views(self => ({
        get journey() {
            return getParent(self, 2); // immediate parent is collection, grandparent is journey
        },
    }))
    .actions(self => ({
        setAssets(assets) {
            self.assets = removeEmptyProperties(assets);

            self.journey.updateLastEditDate();
        },
    }));

const Contact = types.compose('Contact', BaseContact, MortgageContact);

export default Contact;
